import { render, staticRenderFns } from "./DictMapInput.vue?vue&type=template&id=8da006ba&scoped=true&"
import script from "./DictMapInput.vue?vue&type=script&lang=js&"
export * from "./DictMapInput.vue?vue&type=script&lang=js&"
import style0 from "./DictMapInput.vue?vue&type=style&index=0&id=8da006ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da006ba",
  null
  
)

export default component.exports